var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        titulo: "Confirmar Parceria",
        width: _vm.width,
        closeOutside: true
      },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c("div", [
          _c(
            "div",
            {
              staticClass: "border-gray border-radius-5px min-h-50px pdd-10px"
            },
            [_c("span", [_vm._v(_vm._s(_vm.texto))])]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-row gap-1 mt-15px" }, [
            _c("i", { staticClass: "far fa-info-circle color-gray" }),
            _vm._v(" "),
            _c("div", { staticClass: "mt-sub-7px" }, [
              _c("i", { staticClass: "font-size-12px color-gray" }, [
                _vm._v(
                  '\n            Se você clicar em "Não", os dados ficarão disponíveis apenas para a sua visualização,\n            e a outra parte não terá mais acesso a eles.\n          '
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex-between" },
          [
            _c(
              "el-button",
              {
                staticClass: "w-48-per",
                on: {
                  click: function() {
                    return _vm.confirmarParceria(false)
                  }
                }
              },
              [_c("span", [_vm._v("Não")])]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "w-48-per",
                on: {
                  click: function() {
                    return _vm.confirmarParceria(true)
                  }
                }
              },
              [_c("span", [_vm._v("Sim")])]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f2f5318", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f2f5318","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/ConfirmacaoParceria/ConfirmacaoParceria.vue
// module id = null
// module chunks = 